<template>
    <span>
        <router-link
            tag="a"
            :to="`/${organizationSlug}/relays/${row.id}/details`"
            class="view icon-view"
            title="details"
        />
    </span>
</template>

<script>
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'

export default {
    components: {},

    mixins: [canToast, needsOrganizationSlug],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },
}
</script>
